import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
import "./home.css";

const CustomerSection = lazy(() => import("./CustomerSection"));
const Testimonial = lazy(() => import("./Testimonial"));
const CounterSection = lazy(() => import("./CounterSection"));
const WhoWeAreSection = lazy(() => import("./WhoWeAreSection"));
const OurExpertiseSection = lazy(() => import("./OurExpertiseSection"));
const HireSection = lazy(() => import("./HireSection"));
const IndustriesSection = lazy(() => import("./IndustriesSection"));
const QuickConnect = lazy(() => import("./QuickConnect"));
const OurServices = lazy(() => import("./OurServices"));
const AISolutionSection = lazy(() => import("./AISolutionSection"));
const ConnectWithUsSection = lazy(() => import("./ConnectWithUsSection"));

const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          Lentera Technologies | Expert IT Consulting & AI-Driven Software
          Solutions
        </title>
        <meta
          name="description"
          content="Delivering AI-powered software, mobile apps, and enterprise solutions since 2015. Hire skilled developers & designers to grow your business efficiently."
        />
        <meta
          name="keywords"
          content="IT consulting, AI solutions, software development, mobile app development, web development, enterprise applications, custom software, third-party integration, business growth, technology services."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div aria-busy="true" className="h-[400px]" />}>
        <CustomerSection />
        <Testimonial />
        <CounterSection />
        <WhoWeAreSection />
        <OurExpertiseSection />
        <HireSection />
        <IndustriesSection />
        <QuickConnect />
        <OurServices />
        <AISolutionSection />
        <ConnectWithUsSection />
      </Suspense>
    </>
  );
};


export default Home;
